import styled from 'styled-components/macro'
import { FullPage } from 'styles'

export const MultisigStyled = styled(FullPage)``
